<script lang="ts">
  import clsx from "clsx";

  export let show = false,
    showCloseIcon = true,
    onClose: () => void;
</script>

<div
  on:click={onClose}
  on:touchstart|stopPropagation
  on:mousedown|stopPropagation
  class={clsx(
    "left-0 w-full h-full absolute z-50 bg-transparent flex flex-col justify-end transition-top duration-300 ease",
    show ? "top-0" : "top-full"
  )}
  data-testid="bottom-sheet"
>
  <div on:click|stopPropagation class="bg-black rounded-t-2xl relative">
    {#if showCloseIcon}
      <div class="absolute right-4 top-4 cursor-pointer" on:click={onClose}>
        <img src="/assets/png/cross.png" height="16" width="16" />
      </div>
    {/if}
    <slot />
  </div>
</div>
